import { logFrontendError } from "./log_error.js";
import { showToastMessage } from "./toast_message.js";

export function handleFetchError(err) {
    showToastMessage(err, "danger");
    logFrontendError(err);
}